export default __webpack_public_path__ + "static/media/screenshot_selected.3756a2fa.svg";